import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import sprint from "../../assets/img/sprint.png";
import eko from "../../assets/img/eko.png";
import petroCanada from "../../assets/img/petro-canada.png";
import shell_logo from "../../assets/img/shell-logo.jpg";
import ultramar_logo from "../../assets/img/ultramar-logo.jpg";
import sonerco from "../../assets/img/sonerco-logo.png";
import axco from "../../assets/img/axco-logo.png";
import a_w_logo from "../../assets/img/a_w_logo.png";
import recharge_logo from "../../assets/img/recharge_sprint.png";
import gulf from "../../assets/img/gulf.png";
import irving from "../../assets/img/irving.png";
import vp_racing from "../../assets/img/vp_racing.png";
import xtr from "../../assets/img/xtr.png";
import { calculateDistance } from "../../helper/distanceCalc";
import { ImLocation } from "react-icons/im";

export default function SideBarMenu({
  setNavigate,
  navigate,
  geolocation,
  stationFilterData,
}) {
  return (
    <Grid
      item
      xs={12}
      md={6}
      lg={3}
      sx={{
        position: "absolute",
        left: 0,
        top: 15,
        minWidth: "100%",
        height: "97.5%",
        // height: {
        //   xs: "1000px",
        //   lg: "700px",
        // },
        // width: navigate ? "100%" : "0px",
        overflowY: navigate ? "auto" : "hidden",
        backgroundColor: "white",
        boxShadow: navigate ? 3 : 0,
        transform: navigate ? "translateX(0)" : "translateX(-100%)",
        transition: "transform 0.4s ease, width 0.4s ease",
        zIndex: 1300,
      }}
    >
      <Box sx={{ backgroundColor: "var(--white)" }} className="p-5 ">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
            marginBottom: "40px",
          }}
          onClick={() => setNavigate(null)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            style={{ cursor: "pointer", paddingRight: "10px" }}
          >
            <path
              fill="var(--grey-2)"
              transform="matrix(-1 0 0 1 24 0)"
              id="a"
              d="M11.295 4.705a.998.998 0 0 0 0 1.41L16.17 11H5a1 1 0 0 0 0 2h11.17l-4.876 4.884a.998.998 0 0 0 1.411 1.411L20 12l-7.295-7.295a.997.997 0 0 0-1.41 0z"
            ></path>
          </svg>

          <Typography
            variant="body2"
            component={"span"}
            sx={{
              color: "var(--grey-2)",
              marginTop: "6px",
              fontSize: "12px",
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            Retour
          </Typography>
        </Box>

        {(() => {
          const banniere = (navigate?.customFields?.banniere || "").trim();
          const fournisseur = (navigate?.customFields?.fournisseur_dep || "").trim();
          const raisonSociale = navigate?.customFields?.raisonsociale || "";
          const company = navigate?.company || "";
          const combinedName = `${raisonSociale} ${company} ${banniere}`;

          const hasSprint =
            fournisseur === "Sprint" ||
            banniere === "Sprint" ||
            banniere === "Petro-Canada" ||
            banniere === "Shell" ||
            Boolean(navigate?.customFields?.["depanneur-sprint"]) ||
            /sprint/i.test(combinedName);

          const hasPetroCanada =
            banniere === "Petro-Canada" ||
            /petro-canada/i.test(banniere) ||
            /petro-canada/i.test(combinedName);

          const hasGulf =
            banniere === "Gulf" ||
            /gulf/i.test(banniere) ||
            /gulf/i.test(combinedName);

          const hasEko =
            banniere === "Eko" ||
            /eko/i.test(banniere) ||
            /eko/i.test(combinedName);

          const hasXtr =
            banniere === "XTR" ||
            /xtr/i.test(banniere) ||
            /xtr/i.test(combinedName);

          const hasSonerco =
            banniere === "Sonerco" ||
            /sonerco/i.test(banniere) ||
            /sonerco/i.test(combinedName);

          const hasAxco =
            banniere === "Axco" ||
            /axco/i.test(banniere) ||
            /axco/i.test(combinedName);

          const hasVpRacing =
            banniere === "VP FUELS" ||
            banniere === "VP Racing" ||
            /vp\s*(fuels|racing)/i.test(banniere) ||
            /vp\s*(fuels|racing)/i.test(combinedName);

          const hasIrving =
            banniere === "Irving" ||
            /irving/i.test(banniere) ||
            /irving/i.test(combinedName);

          const hasShell =
            banniere === "Shell" ||
            /shell/i.test(banniere) ||
            /shell/i.test(combinedName);

          const hasUltramar =
            banniere === "Ultramar" ||
            /ultramar/i.test(banniere) ||
            /ultramar/i.test(combinedName);

          const hasAw =
            banniere === "A&W" ||
            Boolean(navigate?.customFields?.restaurant_location) ||
            Boolean(navigate?.customFields?.restaurant) ||
            /a&w/i.test(banniere) ||
            /a&w/i.test(combinedName);

          const hasRecharge =
            banniere === "Recharge Sprint" ||
            (Boolean(navigate?.customFields?.borne_de_recharge_ve) &&
              navigate?.customFields?.source === "eddie") ||
            /recharge/i.test(banniere);

          const logosToShow = [
            { id: "sprint", img: sprint, show: hasSprint },
            { id: "petroCanada", img: petroCanada, show: hasPetroCanada },
            { id: "gulf", img: gulf, show: hasGulf },
            { id: "eko", img: eko, show: hasEko },
            { id: "xtr", img: xtr, show: hasXtr },
            { id: "sonerco", img: sonerco, show: hasSonerco },
            { id: "axco", img: axco, show: hasAxco },
            { id: "vp_racing", img: vp_racing, show: hasVpRacing },
            { id: "irving", img: irving, show: hasIrving },
            { id: "shell", img: shell_logo, show: hasShell },
            { id: "ultramar", img: ultramar_logo, show: hasUltramar },
            { id: "a_w", img: a_w_logo, show: hasAw },
            { id: "recharge_sprint", img: recharge_logo, show: hasRecharge },
          ].filter((item) => item.show);

          if (logosToShow.length === 0) return null;

          return (
            <Box className="flex flex-wrap gap-2">
              {logosToShow.map((brand) => (
                <Box
                  key={brand.id}
                  className="w-[50px] h-[50px]"
                  sx={{
                    boxShadow: "1px 1px 1px 0 rgba(10, 10, 10, 0.3)",
                    borderRadius: "4px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    className="w-full h-full object-cover"
                    src={brand.img}
                    alt={brand.id}
                  />
                </Box>
              ))}
            </Box>
          );
        })()}
        {geolocation?.latitude !== 0 && geolocation?.longitude !== 0 && (
          <Box
            sx={{
              color: "var(--grey-2)",
              fontSize: "12px",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            {calculateDistance(
              navigate?.latitude,
              navigate?.longitude,
              geolocation?.latitude,
              geolocation?.longitude
            )}
          </Box>
        )}
        <Box
          sx={{
            color: "var(--grey-1)",
            fontWeight: "bold",
            fontSize: "22px",
            padding: "5px 0px",
          }}
        >
          {navigate?.customFields?.raisonsociale}
        </Box>
        <Box
          sx={{
            color: "var(--grey-2)",
            fontSize: "14px",
            fontWeight: 400,
          }}
        >
          <Typography variant="body2">
            {navigate?.businessAddress?.line1}
          </Typography>
          <Typography variant="body2" sx={{ marginBottom: "20px" }}>
            {navigate?.businessAddress?.city},{" "}
            {navigate?.businessAddress?.postalCode}
          </Typography>
          <Typography variant="h6" sx={{ color: "var(--black)" }}>
            <a href={`tel:${navigate?.businessPhone}`}>
              {navigate?.businessPhone}
            </a>
          </Typography>
          <Box sx={{ marginTop: "20px", marginBottom: "20px" }}>
            <Button
              href={`https://www.google.com/maps/dir/?api=1&destination=${navigate?.latitude},${navigate?.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              disableRipple
              variant="contained"
              sx={{
                justifyContent: "space-between",
                backgroundColor: "transparent",
                color: "var(--primary)",
                borderRadius: "20px",
                border: "2px solid var(--primary)",
                boxShadow: "none",
                transition: "all 0.25s",
                transitionProperty: "background-color, color, transform",
                ":hover": {
                  backgroundColor: "var(--primary)",
                  color: "var(--white)",
                  transform: "scale(1.05)",
                  boxShadow: "none",
                },
              }}
              endIcon={<ImLocation />}
            >
              Directions
            </Button>
          </Box>
          <Typography variant="h6" sx={{ color: "var(--black)" }}>
            Horaire
          </Typography>
          <Box sx={{ marginTop: "20px", marginBottom: "20px" }}>
            <Grid container rowSpacing={2}>
              <Grid item xs={6}>
                <Typography variant="body2">Lundi</Typography>
                <Typography variant="body2">Mardi</Typography>
                <Typography variant="body2">Mercredi</Typography>
                <Typography variant="body2">Jeudi</Typography>
                <Typography variant="body2">Vendredi</Typography>
                <Typography variant="body2">Samedi</Typography>
                <Typography variant="body2">Dimanche</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">{`${navigate?.customFields?.lundideb} - ${navigate?.customFields?.lundifin}`}</Typography>
                <Typography variant="body2">{`${navigate?.customFields?.mardideb} - ${navigate?.customFields?.mardifin}`}</Typography>
                <Typography variant="body2">{`${navigate?.customFields?.mercredideb} - ${navigate?.customFields?.mercredifin}`}</Typography>
                <Typography variant="body2">{`${navigate?.customFields?.jeudideb} - ${navigate?.customFields?.jeudifin}`}</Typography>
                <Typography variant="body2">{`${navigate?.customFields?.vendredideb} - ${navigate?.customFields?.vendredifin}`}</Typography>
                <Typography variant="body2">{`${navigate?.customFields?.samedideb} - ${navigate?.customFields?.samedifin}`}</Typography>
                <Typography variant="body2">{`${navigate?.customFields?.dimanchedeb} - ${navigate?.customFields?.dimanchefin}`}</Typography>
              </Grid>
            </Grid>
          </Box>
          {stationFilterData?.filter(
            (item) => navigate?.customFields?.[item.slug]
          ).length > 0 && (
            <Typography variant="h6" sx={{ color: "var(--black)" }}>
              Services
            </Typography>
          )}
          <Box sx={{ marginTop: "20px", marginBottom: "20px" }}>
            <Grid container rowSpacing={2}>
              {stationFilterData
                ?.filter((item) => navigate?.customFields?.[item.slug]) // Ensure the field exists in customFields
                ?.map((item) => (
                  <Grid
                    item
                    xs={6}
                    key={item.id}
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      transition: "transform .25s",
                      transform: "scale(1)",
                      transformOrigin: "left center",
                      ":hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          width: "35px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "3px solid var(--primary)",
                          borderRadius: "50%",
                          backgroundColor: "var(--white)",
                          color: "var(--primary)",
                          transitionProperty: "fill, background-color",
                          "& svg": {
                            width: "22px",
                            height: "22px",
                          },
                        }}
                      >
                        {item.icon}
                      </Box>
                      <Box
                        sx={{
                          paddingLeft: "10px",
                          fontSize: "13px",
                          width: "100px",
                        }}
                      >
                        {item.name}
                      </Box>
                    </Box>
                  </Grid>
                ))}
            </Grid>
          </Box>
        </Box>
      </Box>
      <Box sx={{ height: "100px" }} />
    </Grid>
  );
}
